var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu"},[_c('el-menu',{attrs:{"default-active":_vm.defaultActive,"collapse":_vm.userStore.isCollapse,"router":"","unique-opened":""}},_vm._l((_vm.userStore.menuRoutes),function(item){return _c('side-menu',{key:item.path,attrs:{"menu":item,"base-path":item.path}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }